/** Browser → Insights Mastra host (product `/insights/thread/*` API). */
export function insightsApiBaseUrl(): string {
  return (
    process.env.NEXT_PUBLIC_INSIGHTS_API_BASE_URL?.replace(/\/$/, "") || "http://localhost:4113"
  );
}

export function insightsApiUrl(path: string): string {
  const base = insightsApiBaseUrl();
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

export function insightsFetch(input: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (!headers.has("Content-Type") && init?.body) {
    headers.set("Content-Type", "application/json");
  }
  const apiKey = process.env.NEXT_PUBLIC_INSIGHTS_API_KEY?.trim();
  if (apiKey && !headers.has("x-api-key")) {
    headers.set("x-api-key", apiKey);
  }
  return fetch(insightsApiUrl(input), { ...init, headers });
}
